import moment from 'moment'
import React from 'react'
import { Table, Button, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { saveAsCSV } from '../helpers/csvhelper'

interface IReverificationsTable {
    tableData: any
}

export default function ReverificationTable(props: IReverificationsTable) {
    const downloadCSV = () => {
        if (!props.tableData || props.tableData.length === 0) {
            alert('No data available to download');
            return;
        }

        // Define CSV headers
        const headers = [
            'S.No',
            'CAP Application Number',
            'CET Roll Number',
            'Candidate Name',
            'Institute Code',
            'Institute Name',
            'Course Name',
            'Fingerprint Status',
            'Face Status',
            'Verification Time'
        ];

        // Convert data to CSV format
        const csvRows = [];
        csvRows.push(headers.join(','));

        props.tableData.forEach((item: any, index: number) => {
            const row = [
                index + 1,
                item?.counsellingUser?.capApplicationNumber || '--',
                item?.counsellingUser?.rollNo || '--',
                (item?.counsellingUser?.name || '--').replace(/,/g, ';'), // Replace commas to avoid CSV issues
                item?.counsellingUser?.allotedInstituteCode || '--',
                (item?.counsellingUser?.allotedInstituteName || '--').replace(/,/g, ';'), // Replace commas
                item?.counsellingUser?.stream || '--',
                item?.fingerprintStatus || '--',
                item?.facialStatus || '--',
                moment(item?.createdAt).format('DD-MM-YYYY HH:mm:ss')
            ];
            csvRows.push(row.join(','));
        });

        const csvData = csvRows.join('\n');
        const fileName = `reverification_data_${moment().format('YYYY-MM-DD_HH-mm-ss')}`;
        saveAsCSV(csvData, fileName);
    };

    return (
        <>
            <div className="mt-4 d-flex justify-content-end">
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={downloadCSV}
                    disabled={!props.tableData || props.tableData.length === 0}
                >
                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                    Download CSV
                </Button>
            </div>
            <Table striped hover responsive>
                <thead>
                    <tr>
                        <th style={{ fontSize: 14 }}>S.No</th>
                        <th style={{ fontSize: 14 }}>CAP Application Number</th>
                        <th style={{ fontSize: 14 }}>CET Roll Number</th>
                        <th style={{ fontSize: 14 }}>Candidate Name</th>
                        <th style={{ fontSize: 14 }}>Institute Code</th>
                        <th style={{ fontSize: 14 }}>Institute Name </th>
                        <th style={{ fontSize: 14 }}>Course Name</th>
                        <th style={{ fontSize: 14 }}>Fingerprint Status</th>
                        <th style={{ fontSize: 14 }}>Face Status</th>
                        <th style={{ fontSize: 14 }}>Verification Time</th>
                    </tr>
                </thead>
                <tbody>
                    {props.tableData?.length > 0 ? (
                        props.tableData.map((item: any, index: number) => (
                            <tr key={item?._id}>
                                <td style={{ fontSize: 12 }}>{index + 1}</td>
                                <td style={{ fontSize: 12 }}>{item?.counsellingUser?.capApplicationNumber || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.counsellingUser?.rollNo || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.counsellingUser?.name || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.counsellingUser?.allotedInstituteCode || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.counsellingUser?.allotedInstituteName || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.counsellingUser?.stream || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.fingerprintStatus || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.facialStatus || '--'}</td>
                                <td style={{ fontSize: 12 }}>{item?.createdAt ? moment(item?.createdAt).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={12} className="text-center">
                                No Data Available
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    )
}
